import { Component, OnDestroy, OnInit, Input, OnChanges, SimpleChanges, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { NgxSpinnerService } from 'ngx-spinner';
import * as _ from 'underscore';
import { ExcelExportHandler } from '../../handlers/export-excel-handler';
import { LEGEND_ARRAY } from '../../constants';

@Component({
  selector: 'app-expandable-table',
  templateUrl: './expandable-table.component.html',
  styleUrls: ['./expandable-table.component.scss'],
})
export class ExpandableTableComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('dt') dt;
  @Input() header = [];
  @Input() tableData = [];
  @Input() rowGroupName: string;
  @Input() page: string;
  @Output() openDialog = new EventEmitter();

  public scrollStrategy: ScrollStrategy;
  public tableHeader: any[];
  public showFilterInput: boolean = false;
  public tableExpanded: boolean = true;
  public filteredtableData: any[] = [];
  public expandedRows: { [key: string]: boolean } = {};
  public searchTerm: string = '';
  public currentPage: number = 0;
  public legendArray = LEGEND_ARRAY;

  constructor(public dialog: MatDialog, private readonly scrollStrategyOptions: ScrollStrategyOptions, private spinner: NgxSpinnerService) {}

  ngOnInit(): void {
    this.scrollStrategy = this.scrollStrategyOptions.noop();
    this.searchTerm = '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.header = this.header?.map((item) => item.toString());
    this.tableHeader = this.header?.map((el) => ({ field: el, header: el, isExpanded: false }));
    if (changes['tableData'] && this.tableData.length > 0) {
      this.currentPage = 0;
      this.clearFilter();
      this.expandedRows = {};
      // const uid = this.filteredtableData[0].uid;
      // this.expandedRows[uid] = true;

      // expanding all parent nodes
      const uids = _.pluck(this.filteredtableData, 'uid'); // Extract all uids
      _.each(uids, (uid) => {
        this.expandedRows[uid] = true; // Set each uid as a key in expandedRows with value true
      });
    }

    if (changes['tableData'] && this.tableData.length == 0) {
      this.filteredtableData = [];
      this.expandedRows = {};
    }
  }

  customFilter(searchTerm: string) {
    this.searchTerm = searchTerm.trim().toLowerCase();

    if (!this.searchTerm) {
      this.filteredtableData = [...this.tableData];
      this.restoreCurrentPage();
    } else {
      this.filteredtableData = this.filterTreeNodes(this.tableData, this.searchTerm);
      if (this.dt) this.dt.first = 0; //reset paginator
    }
  }

  private filterTreeNodes(nodes: any[], searchTerm: string): any[] {
    return nodes.filter((node) => node.node_name.toLowerCase().includes(searchTerm));
  }

  onPageChange(event: any) {
    this.currentPage = Math.floor(event.first / event.rows);
  }

  restoreCurrentPage() {
    if (this.dt) {
      this.dt.first = this.currentPage * (this.dt.rows || 10);
    }
  }

  clearFilter() {
    // this.spinner.show();
    this.filteredtableData = [...this.tableData];
    this.showFilterInput = false;
    this.searchTerm = '';
    this.restoreCurrentPage();

    // setTimeout(() => {
    //   this.spinner.hide();
    // }, 2000);
  }

  getBackgroundColor(cd_ratio: number, node_name: string): string {
    if (node_name === 'C:D (Baseline)' || node_name === 'New C:D' || node_name === 'C:D') {
      if (cd_ratio <= 1.1) {
        return '#ECC3BD';
      } else if (cd_ratio > 1.1 && cd_ratio < 1.15) {
        return '#FDEBCB';
      } else if (cd_ratio >= 1.15) {
        return '#C4D4BD';
      }
    }
    return '';
  }

  // Method to toggle row expansion state
  toggleRow(row: any): void {
    const uid = row.uid;
    this.expandedRows[uid] = !this.expandedRows[uid];
  }

  // Method to check if a row is expanded
  isRowExpanded(row: any): boolean {
    const uid = row.uid;
    return this.expandedRows[uid];
  }

  // Method to clear all expanded rows (optional if needed)
  collapseAllRows(): void {
    this.expandedRows = {};
  }

  // Download Pivot Table data
  async downloadExcel() {
    let fileName = 'Pivot_Table_' + this.rowGroupName;
    let firstColumnHeader = this.rowGroupName;

    // this.excelExportService.exportPivotTableToExcel(this.filteredtableData, this.tableHeader, firstColumnHeader, this.rowGroupName, fileName);
    await ExcelExportHandler.exportPivotTableToExcel(this.filteredtableData, structuredClone(this.tableHeader), firstColumnHeader, this.rowGroupName, fileName);
  }

  openCapacityInterventionsDialog(rowData) {
    this.openDialog.emit(rowData);
  }

  toggleTreeNodeExpansion(toggleType: boolean) {
    const uids = _.pluck(this.filteredtableData, 'uid');
    _.each(uids, (uid) => {
      this.expandedRows[uid] = toggleType;
    });
    this.tableExpanded = toggleType;
  }

  isNumber(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  ngOnDestroy(): void {}
}
